import axios from "axios";

export const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  withCredentials: true // 🔥 ESSENCIAL para cookie httpOnly
});

// 🔒 interceptor global
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const isLoginPage = window.location.pathname === "/login";

    if (error.response?.status === 401 && !isLoginPage) {
      console.warn("🔐 Sessão expirada ou usuário não logado");
      // Use window.location.replace para não sujar o histórico
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);